module.exports = __webpack_public_path__ + "img/CheckSucesso.bbbee87e.svg";